import type React from 'react'
import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { ITextBlockProps } from '../../TextBlock'

import {
  TextBoxMaxLine2Body4,
  TextBoxMaxLine2Footnote5,
} from 'atoms/TextBox/Templates'
import { TextBlock } from '../../TextBlock'

export interface ITextBlockHorizontalType2 extends ITextBlockProps {
  children?:
    | React.ReactElement<ITextBoxProps>
    | React.ReactElement<ITextBoxProps>[]
  title: ITextBoxProps['title']
  description: ITextBoxProps['title']
}

export const TextBlockHorizontalType2 = ({
  title,
  description,
  ...rest
}: ITextBlockHorizontalType2): JSX.Element => {
  return (
    <TextBlock {...rest}>
      <TextBoxMaxLine2Footnote5 title={title} />
      <TextBoxMaxLine2Body4 title={description} />
    </TextBlock>
  )
}
